import {styled} from '@mui/material/styles';

export const PageLayoutContainer = styled('div')({
    display: 'grid',
    minHeight: '100vh',

    gridTemplateAreas: `
        "header header"
        "header-append header-append"
        "top-nav top-nav"
        "fixed-side-nav content-container"
        "footer footer"
    `,
    gridTemplateColumns: 'auto 1fr',
    gridTemplateRows: 'auto auto auto 1fr auto'
});
